import * as React from 'react';

import * as styles from './HintQuestionsLayout.css';

interface IHintQuestionsLayoutProps {
  hintQuestions: React.ReactNode;
}

export const HintQuestionsLayout: React.FC<IHintQuestionsLayoutProps> = ({ hintQuestions }) => {
  return (
    <div className={styles['container']}>
      <div className={styles['hints-container']}>{hintQuestions}</div>
    </div>
  );
};
